import { useState} from 'react';
import { useMutation} from '@apollo/client';
import { UPDATE_GUEST_INFORMATION} from 'graphql/service';

import { useGlobalAlerts } from 'customHooks/useGlobalAlerts';


/**
 * A custom hook for changing guest info
 */


export const useChangeGuestInfo = (onSuccess) => {

  const debug = false;
  
  const { showGlobalError, showGlobalMessage } = useGlobalAlerts();


  useState(false);


  const [updateGuestInformation] = useMutation(UPDATE_GUEST_INFORMATION, {
    onCompleted: (data) => {
      if (debug) {
          console.log ('useChangeGuestInfo data =', data);
      }

      showGlobalMessage("Guest information was successfully changed.");

      // Callback onSuccess
      if (onSuccess) {
        onSuccess();
      }

    },
    onError: (error) => {
      const content = error.message;
      
      showGlobalError(content);

      if (debug) {
        console.log("useChangeGuestInfo error =", error);
      }
    },
  });




  const handleChangeGuestInfo = (bookingId, numberOfKeys, fullName, phoneNumber ) => {
    updateGuestInformation({
      variables: {
        input: {
            bookingId: bookingId,
            phoneNumber: phoneNumber, 
            numberOfKeys: numberOfKeys,
            fullName: fullName
        }
       },
    });
  };

  return {
    handleChangeGuestInfo
  }
}

